module.exports = __webpack_public_path__ + "assets/images/jamesMcmillan1.3c9136e7.jpg";